import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: () => import('@/views/Inicio')
  },
  {
    path: "/formulario1",
    component: () => import('@/views/Formulario1')
  },
  {
    path: "/formulario2",
    component: () => import('@/views/Formulario2')
  },
  {
    path: "/formulario3",
    component: () => import('@/views/Formulario3')
  },
  {
    path: "/formulario4",
    component: () => import('@/views/Formulario4')
  },
  {
    path: "/enviado",
    component: () => import('@/views/Enviado')
  },
  {
    path: "*",
    component: () => import('@/views/Inicio')
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

export default router
